import React from 'react';
import HeroSection from './HeroSection';
import ProblemSection from './ProblemSection';
import SolutionSection from './SolutionSection';
import BookPreviewSection from './BookPreviewSection';
import BenefitsSection from './BenefitsSection';
import BonusSection from './BonusSection';
import OfferSection from './OfferSection';
import FinalCTASection from './FinalCTASection';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-[#F5F5F5]">
      <HeroSection />
      <ProblemSection />
      <SolutionSection />
      <BookPreviewSection />
      <BenefitsSection />
      <BonusSection />
      <OfferSection />
      <FinalCTASection />
    </div>
  );
};

export default LandingPage;